import React from "react";
import { Link } from "react-router-dom";
import ProductSubVariations from "./ProductSubVariations";
import ReUse from "../../services/helpers/reUse";
import GlobalModal from "../../Components/ReUse/Modals/GlobalModal";
import { useState } from "react";
import CustomImage from "../../Components/ReUse/Components/Image";

const ProductVariations = (propsData) => {
  const { options, title } = propsData ?? {};

  const [modalIsOpen, setModalIsOpen] = useState(false);

  const isSize = ReUse.isString({ text: title })
    ? title?.toLowerCase() === "size"
    : false;

  // Function to open the modal
  function openModal() {
    setModalIsOpen(true);
  }

  // Function to close the modal
  function closeModal() {
    setModalIsOpen(false);
  }

  return (
    <>
      <div className="all-radio-btn">
        <div className="radio-name quantity-head">
          <h5>{title}</h5>
        </div>
        {ReUse.voidMapItems(false, options, ProductSubVariations, title)}
        <div className="size-chart-anchor">
          {isSize && <a onClick={openModal}>Size Chart</a>}
        </div>
        <GlobalModal isOpen={modalIsOpen} onRequestClose={closeModal}>
          <div>
            <CustomImage thumbnail="https://th.bing.com/th/id/OIP.Gr7hcjTcqf6vnQBkv0kfbgHaFj?pid=ImgDet&rs=1" />
          </div>
        </GlobalModal>
      </div>
    </>
  );
};

export default ProductVariations;
